/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getStoreApi } from '../../../plugins/helper';
import { useDispatch, useSelector } from "react-redux";
import { all_routes } from "../../../Router/all_routes";
// import { Filter, Sliders } from "react-feather";
import { useNavigate } from "react-router-dom";
// import Select from "react-select";
import { Edit, Trash2,PlusCircle } from "react-feather";
import { Table } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import {set_store_edit} from "../../../core/redux/action";

// import ImageWithBasePath from "../../img/imagewithbasebath";
// import Breadcrumbs from "../../../core/breadcrumbs";
//import StoreModal from "../../../feature-module/settingPages/storeModal";
import { APIgetStores, APIDeleteStore } from "../../../api/settings.ts";

const StoreList = () => {
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dataStore, setDataStore] = useState([])
  // const [editStore, setEditStore] = useState({})
  // const [ setEditStore] = useState({})
  useEffect(() => {
    getStoreApi2();
  }, []);
  //Permissions  
  const permissions = useSelector(state => state.permissions) || [];
  const roleTitle = useSelector(state => state.roleTitle) || '';
  const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

  const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'products' && p.Permission.toLowerCase() === 'view');
  const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'products' && p.Permission.toLowerCase() === 'create');
  const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'products' && p.Permission.toLowerCase() === 'update');
 // const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'products' && p.Permission.toLowerCase() === 'delete');

  if (!canView) {
      return (  
      <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
  )}
  //
  const route = all_routes;

  const getStoreApi2 = async () => {
    
    const res = await APIgetStores({});
    if(res?.response?.stores){
      const storeData = res.response.stores.reverse();
      const nestData = storeData.map(item => {
        const {district, region,prefecture} = item?.locationDetails?item.locationDetails:[];
        return {
          ...item,
          district,
          region,
          prefecture
        }
      })
      setDataStore(nestData)

    }    
  };
  
  const editStore = async (record) => {
    if(record)
      dispatch(set_store_edit(record))
    else
      dispatch(set_store_edit())
    navigate(route.addstore)
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "title",
      sorter: (a, b) => a.title.length - b.title.length,
    },
    {
      title: "Store Code",
      dataIndex: "storeNumber",
      sorter: (a, b) => a.storeNumber.length - b.storeNumber.length,
    },
    {
      title: "City",
      dataIndex: "cityId",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => (
          <span className="badge badge-linesuccess">
            {record.status === 0 ? "Operational" : "Permanently Closed"}
          </span>
        ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            {/* <Link className="me-2 p-2" to="#">
              <Eye className="feather-view" />
            </Link> */}

            {canUpdate && (
              <Link  className="me-2 p-2" to={route.addstore} onClick={() => {
                editStore(record)
              }}>
                <Edit className="feather-edit" />
              </Link>
            )}

            {/* <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#add-units"
              onClick={() => editHandler(record)}
            >
              <Edit className="feather-edit" />
            </Link> */}
            <Link
              className="confirm-text p-2"
              to="#"
              onClick={(e) => showConfirmationAlert(e,record)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  const MySwal = withReactContent(Swal);
  const showConfirmationAlert = (e,record) => {
    e.preventDefault();
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await APIDeleteStore({ id: record._id });
          if (res) {
            await MySwal.fire("Deleted!", "Store has been deleted.", "success");
            console.log('getStoreApi test');
            getStoreApi(localStorage.getItem("roleTitle"));
            await getStoreApi2(); // Ensure this runs after deletion
          }
        } catch (error) {
          console.error('Deletion error:', error);
          await MySwal.fire("Error!", "An error occurred while deleting the store.", "error");
        }
      } else {
        MySwal.close();
      }
    });
  };
  
  // const showConfirmationAlert = (record) => {
  //   MySwal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     showCancelButton: true,
  //     confirmButtonColor: "#00ff00",
  //     confirmButtonText: "Yes, delete it!",
  //     cancelButtonColor: "#ff0000",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       // Await the deletion process here
  //       APIDeleteStore({ id: record._id })
  //         .then(async (res) => {
  //           if (res) {
  //             await MySwal.fire({
  //               title: "Deleted!",
  //               text: "Store has been deleted.",
  //               confirmButtonText: "OK",
  //               customClass: {
  //                 confirmButton: "btn btn-success",
  //               },
  //             });
  //             // Now that deletion is confirmed, fetch the updated data
  //             await getStoreApi();
  //           } else {
  //             throw new Error("Deletion failed");
  //           }
  //         })
  //         .catch(async (error) => {
  //           console.log('error',error);
  //           await MySwal.fire({
  //             title: "Error!",
  //             text: "An error occurred while deleting the store.",
  //             icon: "error",
  //             confirmButtonText: "OK",
  //             customClass: {
  //               confirmButton: "btn btn-danger",
  //             },
  //           });
  //         });
  //     } else {
  //       MySwal.close();
  //     }
  //   }).catch((error) => {
  //     console.error("Error during the confirmation process:", error);
  //   });
  // };
  
  return (
    <div className="page-wrapper">
      <div className="content">
        
        {/* <Breadcrumbs
          maintitle={t?.[l]?.["manage_stores"] || "Manage Stores"}
          subtitle={t?.[l]?.["manageyourstore"] || "Manage Your Store"}
          addButton={t?.[l]?.["addstore"] || "Add Store"}
          clicked={() => setEditStore({})}
        /> */}
        
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>{t?.[l]?.["manage_stores"] || "Manage Stores"}</h4>
              <h6>{t?.[l]?.["manageyourstore"] || "Manage Your Store"}</h6>
            </div>
          </div>
       
          {canCreate ? (
            <div className="page-btn">
              <Link to={route.addstore} className="btn btn-added"  onClick={() => {
                editStore()
              }}>
                <PlusCircle className="me-2 iconsize" />
                {t?.[l]?.["addstore"] || "Add Store"}
              </Link>
            </div>
           ) : null}
          </div> 
        <div className="card table-list-card">
          <div className="card-body">
            {/* <div className="table-top hidden justify-content-end">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />
                  <Link to="#" className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
            </div> */}

            <div className="table-responsive">
              <Table
                className="table datanew"
                columns={columns}
                dataSource={dataStore}
                rowKey={(record) => record.id}
           
              />
            </div>
          </div>
        </div>
      </div>
      {/* edit={editStore} */}
      {/* <StoreModal edit={editStore} reFetchStores={getStoreApi}/> */}
    </div>
  );
};

export default StoreList;